import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=01a4d231&scoped=true"
import script from "./DeleteUser.vue?vue&type=script&lang=js"
export * from "./DeleteUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a4d231",
  null
  
)

export default component.exports